export const FASTPI = 'FASTPI';
export const ANDES = 'ANDES_V1';
export const ROCKY = 'ROCKY';
export const SIERRA = 'SIERRA';
export const ANDES_V2 = 'ANDES';
export const CASCADE = 'CASCADE';
export const HIMALAYAS = "HIMALAYAS";
export const BMA = "BMA";
export const D2D = "D2D";